// export async function generateDeterministicId(seed) {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(seed);

//   const hashBuffer = await crypto.subtle.digest("SHA-256", data);
//   const hashArray = Array.from(new Uint8Array(hashBuffer));
//   const hashHex = hashArray
//     .map((b) => b.toString(16).padStart(2, "0"))
//     .join("");

//   // Return first 24 characters
//   return hashHex.slice(0, 24);
// }
export function extractNumbersFromId(id) {
  return id.replace(/[a-zA-Z]/g, "");
}

export async function generateUserKeyPair(username, password) {
  const keyPair = await crypto.subtle.generateKey(
    { name: "ECDH", namedCurve: "P-256" },
    true,
    ["deriveBits"]
  );

  const publicKeyBuf = await crypto.subtle.exportKey("raw", keyPair.publicKey);
  const privateKeyBuf = await crypto.subtle.exportKey(
    "pkcs8",
    keyPair.privateKey
  );

  const salt = crypto.getRandomValues(new Uint8Array(16));
  const iv = crypto.getRandomValues(new Uint8Array(12));

  const pwKey = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(password),
    "PBKDF2",
    false,
    ["deriveKey"]
  );

  const aesKey = await crypto.subtle.deriveKey(
    { name: "PBKDF2", salt, iterations: 100000, hash: "SHA-256" },
    pwKey,
    { name: "AES-GCM", length: 256 },
    false,
    ["encrypt"]
  );

  const encryptedPrivateKeyBuf = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    aesKey,
    privateKeyBuf
  );

  return {
    patientId: username,
    publicKey: btoa(String.fromCharCode(...new Uint8Array(publicKeyBuf))),
    encryptedPrivateKey: btoa(
      String.fromCharCode(...new Uint8Array(encryptedPrivateKeyBuf))
    ),
    salt: btoa(String.fromCharCode(...salt)),
    iv: btoa(String.fromCharCode(...iv)),
    rawPrivateKey: privateKeyBuf,
  };
}
export async function decryptPrivateKeyBackup(encrypted, salt, iv, password) {
  const encData = Uint8Array.from(atob(encrypted), (c) => c.charCodeAt(0));
  const saltBuf = Uint8Array.from(atob(salt), (c) => c.charCodeAt(0));
  const ivBuf = Uint8Array.from(atob(iv), (c) => c.charCodeAt(0));

  const pwKey = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(password),
    "PBKDF2",
    false,
    ["deriveKey"]
  );

  const aesKey = await crypto.subtle.deriveKey(
    { name: "PBKDF2", salt: saltBuf, iterations: 100000, hash: "SHA-256" },
    pwKey,
    { name: "AES-GCM", length: 256 },
    false,
    ["decrypt"]
  );

  const decrypted = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv: ivBuf },
    aesKey,
    encData
  );

  return new Uint8Array(decrypted);
}
